var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    {
      staticClass:
        "document-mobile-banner d-flex align-end pa-4 mb-6 overflow-hidden position-relative",
      style: _setup.bannerStyle,
      attrs: { "data-qa": "document_mobile_banner" },
    },
    [
      _c("div", {
        staticClass: "info-banner__overlay_darken position-absolute",
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "text-subtitle-1 bg-gray-0--text pa-4 rounded w-100 position-relative",
        },
        [
          _c("ul", { staticClass: "document-mobile-banner__list ma-0 pa-0" }, [
            _c("li", { staticClass: "mb-3" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_setup.t("ООО «МЕДРОКЕТ»", _setup.options)) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _vm.isRussia
              ? _c("li", { staticClass: "mb-3" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_setup.t("ОГРН 1122311003760", _setup.options)) +
                      "\n      "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isRussia
              ? _c("li", [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _setup.t(
                          "ЭЛ № ФС 77 - 89293 от 01.04.2025 г",
                          _setup.options
                        )
                      ) +
                      "\n      "
                  ),
                ])
              : _vm._e(),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }